




















































import { Vue, Component } from 'vue-property-decorator';
import { Icon, Toast } from 'vant';
import moment from 'moment';
import QRCode from 'qrcode';
import { vueCanvasPoster } from 'vue-canvas-poster';
import { getDetail } from '../api';
import VoteButton from '../components/VoteButton.vue';
import Canvas from '../components/Canvas.vue';

Vue.use(Icon).use(Toast);

@Component({
  components: {
    vueCanvasPoster,
    VoteButton,
    Canvas,
  },
})
export default class Detail extends Vue {
  detailData: any = {};
  painting: any = {};

  async created() {
    const areaAll = [
      '重庆大学城第一中学',
      '重庆市第一实验中学',
      '重庆师范大学附属中学',
      '大学城人民小学',
      '富力南开小学',
      '大学城树人小学',
      '南开景阳小学',
      '树人思贤小学',
      '重庆师范大学附属小学',
      '虎溪辖区居民',
    ];
    const retDetail: any = await getDetail(this.$route.query.id);

    if (retDetail.data) {
      retDetail.data.createtime = moment(
        Number(retDetail.data.createtime * 1000),
      ).format('YYYY-MM-DD HH:mm:s');
      retDetail.data.area_text = areaAll[Number(retDetail.data.area_id) - 1];
    }

    this.detailData = retDetail.data;
  }

  onPosterBtnClick() {
    (this.$refs.myPoster as Canvas).showCanvas = !(this.$refs
      .myPoster as Canvas).showCanvas;
  }

  updateZan() {
    console.log('update zan');
    this.detailData.votes = Number(this.detailData.votes) + 1;
    this.$emit('updateZan');
  }
}
